import Draft from "draft-js";

/**
 * Helper to create Draft.SelectionState objects from plain JS objects
 */
export const createSelection = (props: {
  anchorKey: string;
  anchorOffset: number;
  focusKey: string;
  focusOffset: number;
  isBackward: boolean;
  hasFocus: boolean;
}): Draft.SelectionState =>
  Draft.SelectionState.createEmpty(props.anchorKey).merge(
    props,
  ) as Draft.SelectionState;
